'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var moment = _interopDefault(require('moment-timezone'));
var icons = require('@material-ui/icons');
var styledComponents = require('./styled-components.js');
var utils = require('./utils.js');

var WeekDaySelector = function (props) {
    var daySelect = props.daySelect, _a = props.hasWeekSelector, hasWeekSelector = _a === void 0 ? true : _a, selectedDay = props.selectedDay, _b = props.daysWithCount, daysWithCount = _b === void 0 ? {} : _b, updateWeek = props.updateWeek, week = props.week, _c = props.countToolTipText, countToolTipText = _c === void 0 ? '' : _c;
    var theme = core.useTheme();
    var selectDay = function (event) {
        if (event.currentTarget.dataset.value) {
            daySelect(moment(parseInt(event.currentTarget.dataset.value, 10)));
        }
    };
    var backOneWeek = function () {
        updateWeek(moment(week.subtract(1, 'week')));
    };
    var forwardOneWeek = function () {
        updateWeek(moment(week.add(1, 'week')));
    };
    var daysThisWeek = utils.getDaysThisWeek(selectedDay);
    var formattedDaysWithCount = utils.formatUnconfirmedKeys(daysWithCount);
    return (React__default.createElement(styledComponents.Main, null,
        hasWeekSelector && (React__default.createElement(styledComponents.IconDiv, { onClick: backOneWeek, "data-testid": 'back-one-week' },
            React__default.createElement(icons.ChevronLeft, { style: { color: '#aaaaaa', fontSize: '2.5rem' } }))),
        daysThisWeek.map(function (d) {
            var _a;
            var formattedDay = d.format('ddd-D');
            var selected = selectedDay.format('ddd-D') === formattedDay;
            var styles = {};
            if (selected) {
                styles.backgroundColor = theme.palette.secondary.dark;
                styles.borderColor = theme.palette.border.main;
                styles.color = theme.palette.text.primary;
            }
            return (React__default.createElement(styledComponents.SpacedBadge, { badgeContent: React__default.createElement(styledComponents.CountToolTip, { title: React__default.createElement("span", null, countToolTipText), arrow: false, classes: styledComponents.toolTipStyles() },
                    React__default.createElement("span", null, (_a = formattedDaysWithCount[formattedDay]) !== null && _a !== void 0 ? _a : 0)), color: 'error', overlap: 'circle', invisible: !formattedDaysWithCount[formattedDay], style: { flex: 3 }, key: d.format('ddd-D') },
                React__default.createElement(styledComponents.Card, { onClick: selectDay, "data-value": d, style: styles }, d.format('ddd - D'))));
        }),
        hasWeekSelector && (React__default.createElement(styledComponents.IconDiv, { onClick: forwardOneWeek, "data-testid": 'forward-one-week' },
            React__default.createElement(icons.ChevronRight, { style: { color: '#aaaaaa', fontSize: '2.5rem' } })))));
};

module.exports = WeekDaySelector;
